'use strict';

import angular from 'angular';

angular.module('formApp').factory('engineVersionHandler', [
  function () {
    const engineVersions = ['1', '2'];

    const migrateField = (field, targetVersion) => {
      switch (field.type) {
        case 'H1':
        case 'H2':
        case 'TEXT':
          if (targetVersion === '2') {
            if (field.source && field.source.service === 'prozess' && field.source.variableName) {
              field.label = `{{prozessinstanzvariable:${field.source.variableName}}}`;
              delete field.source;
            }
            if (field.source && field.source.service !== 'prozess') {
              alert(
                `Das Feld von Typ ${field.type} mit der Id "${field.id}" konnte nicht migriert werden, da die source "${field.source.service}" ungültig ist.`
              );
            }
          }

          return field;

        case 'DATE':
          if (targetVersion === '2' && field.pickerDisabled) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalDateConfig'
              };
            }
            field.additionalConfig.pickerDisabled = field.pickerDisabled;
            delete field.pickerDisabled;
          } else if (targetVersion === '1' && field.additionalConfig) {
            field.pickerDisabled = field.additionalConfig.pickerDisabled;
            delete field.additionalConfig;
          }

          return field;

        case 'CHECKBOX':
          if (targetVersion === '2' && field.layout) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalCheckboxConfig'
              };
            }
            field.additionalConfig.layout = field.layout;
            delete field.layout;
          } else if (targetVersion === '1' && field.additionalConfig) {
            field.layout = field.additionalConfig.layout;
            delete field.additionalConfig;
          }

          return field;

        case 'BOOLEAN':
          if (targetVersion === '2' && field.layout) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalBooleanConfig'
              };
            }
            field.additionalConfig.layout = field.layout;
            delete field.layout;
          } else if (targetVersion === '1' && field.additionalConfig) {
            field.layout = field.additionalConfig.layout;
            delete field.additionalConfig;
          }

          return field;

        case 'RADIO_BUTTONS':
          if (targetVersion === '2' && field.layout) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalRadioButtonConfig'
              };
            }
            field.additionalConfig.layout = field.layout;
            delete field.layout;
          } else if (targetVersion === '1' && field.additionalConfig) {
            if (field.additionalConfig.layout) {
              field.layout = field.additionalConfig.layout;
              delete field.additionalConfig.layout;
            }
            if (!(field.additionalConfig.styling)) {
              delete field.additionalConfig;
            }
          }

          return field;

        case 'DROPDOWN_SINGLE_SELECT':
          if (targetVersion === '2' && field.filterable) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalDropdownSingleSelectConfig'
              };
            }

            field.additionalConfig.filterable = field.filterable;
            delete field.filterable;
          } else if (targetVersion === '1' && field.additionalConfig) {
            field.filterable = field.additionalConfig.filterable;
            delete field.additionalConfig;
          }

          return field;

        case 'DROPDOWN_SINGLE_SELECT_AJAX':
          if (targetVersion === '2' && field.filterable) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalDropdownSingleSelectAjaxConfig'
              };
            }

            field.additionalConfig.filterable = field.filterable;
            delete field.filterable;
          } else if (targetVersion === '1' && field.additionalConfig) {
            field.filterable = field.additionalConfig.filterable;
            delete field.additionalConfig;
          }

          return field;

        case 'GEO_MAP':
          if (
            targetVersion === '2' &&
            (field.controlParameters || field.controlParametersExpression || field.hideElements)
          ) {
            if (!field.additionalConfig) {
              field.additionalConfig = {
                '@type': 'AdditionalGeoMapConfig'
              };
            }
            if (field.controlParameters) {
              field.additionalConfig.controlParameters = field.controlParameters;
              delete field.controlParameters;
            }
            if (field.controlParametersExpression) {
              field.additionalConfig.controlParametersExpression = field.controlParametersExpression;
              delete field.controlParametersExpression;
            }
            if (field.hideElements) {
              field.additionalConfig.hideElements = field.hideElements;
              delete field.hideElements;
            }
          } else if (targetVersion === '1') {
            if (field.additionalConfig.controlParameters) {
              field.controlParameters = field.additionalConfig.controlParameters;
              delete field.additionalConfig.controlParameters;
            }
            if (field.additionalConfig.controlParametersExpression) {
              field.controlParametersExpression = field.additionalConfig.controlParametersExpression;
              delete field.additionalConfig.controlParametersExpression;
            }
            if (field.additionalConfig.hideElements) {
              field.hideElements = field.additionalConfig.hideElements;
              delete field.additionalConfig.hideElements;
            }

            delete field.additionalConfig;
          }

          return field;

        case 'DROPDOWN_MULTIPLE_SELECT':
        case 'TWO_LIST_SELECT':
          if (targetVersion === '2') {
            field.type = 'CHECKBOX';
          }

          return field;

        case 'FILE':
          if (targetVersion === '2') {
            field.type = 'MULTIPLE_FILE';
            if (!field.validationRules) {
              field.validationRules = [];
            }
            field.validationRules.push({
              '@type': 'MaxFileCountValidator',
              maxFileCount: 1
            });
          }

          return field;

        case 'SUBMITTED_WITH_NPA_INFO':
          if (targetVersion === '2') {
            alert(
              `Das Feld von Typ ${field.type} mit der Id "${field.id}" konnte nicht migriert werden, da dieser Feldtyp in der Engine-Version 2 nicht mehr unterstützt wird.`
            );
          }

          return field;

        default:
          return field;
      }
    };

    return {
      migrateEngineVersion: (form, targetVersion) => {
        if (!form) {
          console.log('Keine gültiges Formular übergeben: ', form);
          return;
        }

        if (!engineVersions.includes(targetVersion)) {
          console.log('Keine gültige engineVersion übergeben:', targetVersion);
          return;
        }

        form.sections.forEach((section) => {
          section.fieldGroups.forEach((fieldGroup) => {
            fieldGroup.rows.forEach((row) => {
              row.fields.forEach((field, index) => {
                const migratedFieldCopy = migrateField(angular.copy(field), targetVersion);
                row.fields[index] = migratedFieldCopy;
              });
            });
          });
        });
      }
    };
  }
]);
